import { Route, Switch } from "react-router-dom";
import Tabs from "./DashboardTabs";

function DashboardPages() {
  return (
    <Switch>
      <Route path="/financeiro/dashboard" component={Tabs} />
    </Switch>
  );
}

export default DashboardPages;
